import { Directive, HostListener, ElementRef, Input } from '@angular/core';

export interface ISwapClasses {
  onMouseIn: string[];
  onMouseOut: string[];
}

@Directive({
  selector: '[appClassOnHover]',
})
export class ClassOnHoverDirective {
  @Input() classOnHover: string[] = [];
  @Input() swapClasses: ISwapClasses;

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  constructor(readonly elementRef: ElementRef<any>) {}

  @HostListener('mouseenter') onMouseEnter(): void {
    if (this.classOnHover.length) {
      this.elementRef.nativeElement.classList.add(...this.classOnHover);
    }
    if (this.swapClasses) {
      this.elementRef.nativeElement.classList.add(...this.swapClasses.onMouseIn);
      this.elementRef.nativeElement.classList.remove(...this.swapClasses.onMouseOut);
    }
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    if (this.classOnHover.length) {
      this.elementRef.nativeElement.classList.remove(...this.classOnHover);
    }
    if (this.swapClasses) {
      this.elementRef.nativeElement.classList.add(...this.swapClasses.onMouseOut);
      this.elementRef.nativeElement.classList.remove(...this.swapClasses.onMouseIn);
    }
  }
}
